import { FC } from "react";

import { showRenameCourseModal } from "./AddOrRenameCourseModalUtils";
import { CourseOptionsMenu } from "./CourseOptionsMenu";

import { COURSE_GROUPING_ID_QUERY_PARAM, COURSE_ID_QUERY_PARAM } from "components/constants";
import { ListItem } from "mds/components/ListItem";
import { TextBooksIcon } from "mds/icons";
import { courseSelectors } from "store/selectors";
import { useObjectSelector } from "store/store-hooks";
import { ADMIN_COURSE_EVENT_PREFIX } from "utils/amplitude";
import { getCourseDisplayTitle } from "utils/course";
import { useQueryParamsActions } from "utils/routing";

type CourseListItemProps = {
  courseId: string;
  canEdit: boolean;
};

export const CourseListItem: FC<CourseListItemProps> = ({ courseId, canEdit }) => {
  const { setQueryParams } = useQueryParamsActions();
  const course = useObjectSelector(
    (state) => courseSelectors.selectById(state, courseId),
    ["id", "code", "title"],
  );

  if (!course) {
    return null;
  }
  return (
    <ListItem
      eventName={`${ADMIN_COURSE_EVENT_PREFIX}Course selected`}
      eventProperties={{ course: course.code }}
      kind="primary"
      onClick={() => {
        setQueryParams({
          [COURSE_ID_QUERY_PARAM]: course.id,
          [COURSE_GROUPING_ID_QUERY_PARAM]: null,
        });
      }}
    >
      <div className="body-m flex w-full min-w-12 items-center justify-between gap-2">
        <div className="flex w-full min-w-12 items-center gap-2">
          <TextBooksIcon />
          <div className="truncate">{getCourseDisplayTitle(course)}</div>
        </div>

        {canEdit && (
          <CourseOptionsMenu courseId={courseId} onRename={() => showRenameCourseModal(courseId)} />
        )}
      </div>
    </ListItem>
  );
};
